import { forwardRef } from 'react';
import styles from './StyleConstants.module.css';

export const H2 = forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(function H2({ className, children, ...props }, ref) {
  return (
    <h2
      ref={ref}
      className={`${styles.h2}${className ? ` ${className}` : ''}`}
      {...props}
    >
      {children}
    </h2>
  );
});

export const P = forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(function P({ className, children, ...props }, ref) {
  return (
    <p
      ref={ref}
      className={`${styles.p}${className ? ` ${className}` : ''}`}
      {...props}
    >
      {children}
    </p>
  );
});
